













import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import ContentsPage from "@/components/ContentsPage.vue";
import ProjectionFundamental from "@/views/VisuCom/ProjectionFundamental.vue";
import ProjectionTips from "@/views/VisuCom/ProjectionTips.vue";
import ProjectionInPractise from "@/views/VisuCom/ProjectionInPractise.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    ContentsPage,
    ProjectionFundamental,
    ProjectionTips,
    ProjectionInPractise,
    Footer,
  },
})
export default class Projection extends Vue {
  protected ContentsPageProjection = [
    {
      ContentsTitle: "LES FONDAMENTAUX DU DIAPORAMA",
      ContentsPath: "/Diaporama/Fondamentaux",
      ContentsImage: "/thumbnail5.png",
    },
    {
      ContentsTitle: "CONSEILS ET ASTUCES",
      ContentsPath: "/Diaporama/Astuces",
      ContentsImage: "/thumbnail1.png",
    },
    {
      ContentsTitle: "EN PRATIQUE...",
      ContentsPath: "/Diaporama/EnPratique",
      ContentsImage: "/thumbnail7.png",
    },
  ];
}
